if (!customElements.get('media-gallery')) {
	customElements.define(
		'media-gallery',
		class MediaGallery extends HTMLElement {
			constructor() {
				super();
				this.elements = {
					liveRegion: this.querySelector('[id^="GalleryStatus"]'),
					viewer: this.querySelector('[id^="GalleryViewer"]'),
					thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
				};
				this.mql = window.matchMedia('(min-width: 750px)');
				if (!this.elements.thumbnails) return;

				this.elements.viewer.addEventListener(
					'slideChanged',
					debounce(this.onSlideChanged.bind(this), 500),
				);
				this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
					mediaToSwitch
						.querySelector('button')
						.addEventListener(
							'click',
							this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false),
						);
				});
				if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
			}

			onSlideChanged(event) {
				const thumbnail = this.elements.thumbnails.querySelector(
					`[data-target="${event.detail.currentElement.dataset.mediaId}"]`,
				);
				this.setActiveThumbnail(thumbnail);
			}

			setActiveMedia(
				mediaId,
				prepend,
				isInputWithFont,
				featuredImgSrc,
				noRender,
				productSku,
				isInitial,
				isInputWithMetal,
			) {
				const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
				this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
					element.classList.remove('is-active');
				});
				activeMedia.classList.add('is-active');

				// newFont changes start
				const additionalImg = document.querySelector('.additional-main-img img');

				const additionalImgMedia = document.querySelector(
					'.additional-main-img .product__media-toggle',
				);
				if(additionalImgMedia){
					additionalImgMedia.setAttribute('data-media-id', mediaId.split('main-')[1]);
				}
				if (!isInitial) {
					additionalImg.removeAttribute('srcset');
				}
				if (additionalImg) {
					additionalImg.src = featuredImgSrc;
				}
				const activeThumbnailEl = document.querySelector('.active-thumbnail');
				const activeThumbnailImg = activeThumbnailEl?.querySelector('img');
				const firstMediaListItem = document.querySelector('.product__media-item:first-child');

				const activeMediaId = activeMedia.getAttribute('data-media-id').split('main-')[1];
				if (activeThumbnailImg?.src === additionalImg.src) {
					if (!isInitial) {
						firstMediaListItem.querySelector('img').removeAttribute('srcset');
					}
					firstMediaListItem.querySelector('img').src = activeThumbnailImg?.src;
					firstMediaListItem
						.querySelector('.product__media-toggle')
						.setAttribute('data-media-id', activeMediaId);
					activeThumbnailEl
						.querySelector('.product__media-toggle')
						.setAttribute('data-media-id', activeMediaId);
				} else {
					if (window.innerWidth >= 750) {

						firstMediaListItem.querySelector('img').src = activeThumbnailImg?.src;
						
						activeThumbnailEl?.querySelector('img').click();
					} else {
						firstMediaListItem.querySelector('img').removeAttribute('srcset');
						firstMediaListItem.querySelector('img').src = additionalImg?.src;
						firstMediaListItem
						.querySelector('.product__media-toggle')
						.setAttribute('data-media-id', activeMediaId);
					}
				}
				// newFont changes end

				const metalInputs = document.querySelectorAll("input[name='Metal']");
				const pickedMetal = Array.from(metalInputs).find((radio) => radio.checked);
				const metalAbbreviation = pickedMetal.dataset.metalAbbreviation;
				const activeThumbnailImgEl = document.querySelector('.active-thumbnail img');
				const imageHolders = document.querySelectorAll(
					'ul.product__media-list.desktop-media-list li:not(.product__media-item--variant)',
				);
				Array.from(imageHolders).forEach((el) => {
					const imgEl = el.querySelector('img');
					if (
						imgEl.src.includes(`-${metalAbbreviation}`) &&
						!el.classList.contains('additional-main-img')
					) {
						const LIST_OF_METAL_ABBR = ['Y', 'W', 'R', 'X', 'Z', 'U', 'V', 'TA', 'TG'];
						const activeMetalAbbreviation = LIST_OF_METAL_ABBR.find((el) =>
							activeThumbnailImgEl?.src.includes(`-${el}`),
						);

						const imgElVariantSplit = imgEl.src?.split(`-${metalAbbreviation}-`)[1]?.split('')
						const imgElVariantIndex = imgElVariantSplit?.[1] == "_" ? imgElVariantSplit?.[0] : `${imgElVariantSplit?.[0]}${imgElVariantSplit?.[1]}`;
						
						const activeThumbtailVariantSplit = activeThumbnailImgEl?.src
							?.split(`-${activeMetalAbbreviation}-`)[1]
							?.split('')

						const activeThumbtailVariantIndex = activeThumbtailVariantSplit?.[1] == "_" ? activeThumbtailVariantSplit?.[0] : `${activeThumbtailVariantSplit?.[0]}${activeThumbtailVariantSplit?.[1]}`;
						if (
							imgElVariantIndex === activeThumbtailVariantIndex &&
							imgElVariantIndex &&
							activeThumbtailVariantIndex
						) {
							const thumbnailEls = document.querySelectorAll('.product__media-item-secondary');
							const firstMediaListItem = document.querySelector('.product__media-item:first-child');
							const isToggledEl = Array.from(thumbnailEls).find((el) => {
								return el.classList.contains('active-thumbnail');
							});
							if (isToggledEl) {
								isToggledEl.classList.remove('active-thumbnail');
							}

							firstMediaListItem.querySelector('img').removeAttribute('srcset');
							firstMediaListItem.querySelector('img').src = imgEl.src;
							el.classList.add('active-thumbnail');
						}
					}
				});

				if (isInputWithMetal) {
					const activeThumbnailEl = document.querySelector('.active-thumbnail');
					activeThumbnailEl?.querySelector('img').click();
				}

				document.querySelectorAll('[data-media-id-mobileDropDown]').forEach((element) => {
					element.classList.remove('is-active');
				});

				const activeMediaFromDropDown = document.querySelector(
					`[data-media-id-mobileDropDown="${mediaId}"]`,
				);
				if (activeMediaFromDropDown) {
					document.querySelectorAll('[data-media-id-mobileDropDown]').forEach((element) => {
						element.classList.remove('is-active');
					});
					activeMediaFromDropDown.classList.add('is-active');
				}

				if (window.innerWidth <= 749 && prepend) {
					activeMediaFromDropDown &&
						activeMediaFromDropDown.parentElement.prepend(activeMediaFromDropDown);
					if (this.elements.thumbnails) {
						const activeThumbnail = this.elements.thumbnails.querySelector(
							`[data-target="${mediaId}"]`,
						);
						activeThumbnail.parentElement.prepend(activeThumbnail);
					}
					if (this.elements.viewer.slider) this.elements.viewer.resetPages();
				}

				if (prepend && isInputWithFont) {
					activeMedia.parentElement.prepend(activeMedia);

					activeMediaFromDropDown &&
						activeMediaFromDropDown.parentElement.prepend(activeMediaFromDropDown);
					if (this.elements.thumbnails) {
						const activeThumbnail = this.elements.thumbnails.querySelector(
							`[data-target="${mediaId}"]`,
						);
						activeThumbnail.parentElement.prepend(activeThumbnail);
					}
					if (this.elements.viewer.slider) this.elements.viewer.resetPages();
				}

				this.preventStickyHeader();
				window.setTimeout(() => {
					if (this.elements.thumbnails) {
						activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
					}
				});
				this.playActiveMedia(activeMedia);

				if (!this.elements.thumbnails) return;
				const activeThumbnail = this.elements.thumbnails.querySelector(
					`[data-target="${mediaId}"]`,
				);
				this.setActiveThumbnail(activeThumbnail);
				this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
			}

			setActiveThumbnail(thumbnail) {
				if (!this.elements.thumbnails || !thumbnail) return;

				this.elements.thumbnails
					.querySelectorAll('button')
					.forEach((element) => element.removeAttribute('aria-current'));
				thumbnail.querySelector('button').setAttribute('aria-current', true);
				if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

				this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
			}

			announceLiveRegion(activeItem, position) {
				const image = activeItem.querySelector('.product__modal-opener--image img');
				if (!image) return;
				image.onload = () => {
					this.elements.liveRegion.setAttribute('aria-hidden', false);
					this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
						'[index]',
						position,
					);
					setTimeout(() => {
						this.elements.liveRegion.setAttribute('aria-hidden', true);
					}, 2000);
				};
				image.src = image.src;
			}

			playActiveMedia(activeItem) {
				window.pauseAllMedia();
				const deferredMedia = activeItem.querySelector('.deferred-media');
				if (deferredMedia) deferredMedia.loadContent(false);
			}

			preventStickyHeader() {
				this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
				if (!this.stickyHeader) return;
				this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
			}

			removeListSemantic() {
				if (!this.elements.viewer.slider) return;
				this.elements.viewer.slider.setAttribute('role', 'presentation');
				this.elements.viewer.sliderItems.forEach((slide) =>
					slide.setAttribute('role', 'presentation'),
				);
			}
		},
	);
}
